import React from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

interface AdminPasswordProps {
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mutationType?: "edit" | "add";
}

const AdminPassword: React.FC<AdminPasswordProps> = ({
  onPasswordChange,
  mutationType,
}) => {
  return (
    <Form.Item
      name={["systemUser", "password"]}
      label="Password"
      rules={[
        {
          required: mutationType !== "edit",
          message: "Please enter the password!",
        },
      ]}
    >
      <Input.Password
        iconRender={(visible) =>
          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
        }
        onChange={onPasswordChange}
      />
    </Form.Item>
  );
};

export default AdminPassword;
